import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { Typography } from "@mui/material";

interface CustomTooltipProps extends Omit<TooltipProps, "title" | "children" | "placement"> {
  title: React.ReactNode;
  children: React.ReactElement;
  arrowDirection?: "top" | "bottom" | "left" | "right";
}

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    PopperProps={{
      container: typeof window !== 'undefined' ? (document.fullscreenElement || document.body) : undefined,
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#192529",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#192529",
    borderRadius: "10px",
    padding: "4px 12px",
    boxShadow: "0px 0px 4px 0px rgba(4, 20, 26, 0.60), 0px 3px 6px 0px rgba(5, 22, 28, 0.60)",
  },
}));

const InfoHoverTooltip: React.FC<CustomTooltipProps> = ({
  title,
  children,
  arrowDirection = "top",
  ...props
}) => {
  return (
    <CustomTooltip
      title={
        typeof title === "string" ? (
          <Typography variant="caption" sx={{ color: "#ffffff" }}>
            {title}
          </Typography>
        ) : (
          title
        )
      }
      TransitionComponent={Zoom}
      arrow
      placement={arrowDirection}
      {...props}
    >
      {children}
    </CustomTooltip>
  );
};

export default InfoHoverTooltip;
